import {
  createAnalytics,
  createIdentityJwtTokenGetter
} from '@3plearning/mx-teacher-analytics';
import appEvents from './events';

const APP_NAME = 'course-assign';
const TEACHER_TOTTER_PRODUCT = 'mathletics';
const CORE_GROUP = 'core';

function resolveEnabledGroups(trackingGroups) {
  if (!trackingGroups) {
    return null;
  }

  const groups = trackingGroups
    .split(',')
    .map((group) => group.trim())
    .filter(Boolean);

  return [...groups, CORE_GROUP];
}

// A failed build falls back to teacher-totter off so analytics never breaks the
// app (the package throws if teacher-totter is enabled without a sync URL).
export default function buildAnalyticsClient(config) {
  const {
    environment,
    posthogEnabled,
    trackingGroups,
    teacherTotterEnabled,
    teacherTotterSyncUrl,
    identityGatewayUrl,
    getAppAuthToken
  } = config;

  const posthog = posthogEnabled ? { enabled: true } : { enabled: false };

  const analyticsConfig = {
    app: APP_NAME,
    environment: environment || 'production',
    providers: {
      posthog,
      teacherTotter: {
        enabled: Boolean(teacherTotterEnabled && teacherTotterSyncUrl),
        syncUrl: teacherTotterSyncUrl,
        product: TEACHER_TOTTER_PRODUCT,
        getAuthToken: createIdentityJwtTokenGetter({
          identityGatewayUrl,
          getAppAuthToken
        })
      }
    },
    enabledFeatureGroups: resolveEnabledGroups(trackingGroups),
    events: appEvents
  };

  try {
    return createAnalytics(analyticsConfig);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      '[analytics] Initialisation failed; continuing with teacher-totter disabled.',
      error
    );

    return createAnalytics({
      ...analyticsConfig,
      providers: {
        ...analyticsConfig.providers,
        teacherTotter: {
          ...analyticsConfig.providers.teacherTotter,
          enabled: false
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./analytics/create-client.js